import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Avatar,
  Toolbar,
  IconButton,
  List,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material/";
import { useTranslation } from "react-i18next";
import SettingsIcon from "@mui/icons-material/Settings";

import Links from "./Links";
import RasilniIcon from "../../../assets/icons/RasilniIcon";
import ThemeSubMenu from "../../../components/shared/ThemeDropdown";

import useStyles from "./style.js";
import { pageTitleBgColor } from "../../../constants/colors.js";

const Header = ({ handleDrawerToggle }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [anchorElUserSetting, setAnchorElUserSetting] = useState(null);
  const [anchorElTheme, setAnchorElTheme] = useState(null);
  const [themeSubMenuOpen, setThemeSubMenuOpen] = useState(false);

  const { userInfo } = useSelector((state) => state.user);
  const { t } = useTranslation();

  const handleUserSettingClick = (event) => setAnchorElUserSetting(event.currentTarget);
  const handleUserSettingClose = () => setAnchorElUserSetting(null);
  const handleThemeClick = (event) => {
    setAnchorElTheme(event.currentTarget);
    setThemeSubMenuOpen(true);
  };
  const handleThemeClose = (e) => {
    e.stopPropagation();
    setThemeSubMenuOpen(false);
    setAnchorElUserSetting(null);
    setAnchorElTheme(null);
  };

  const userSettingOpen = Boolean(anchorElUserSetting);
  const userSettingId = userSettingOpen ? "simple-popover" : undefined;
  const themeOpen = Boolean(anchorElTheme);

  return (
    <div className={classes.root}>
      <Toolbar className={classes.toolbar}>
        {/* First section - logo */}
        <div className={classes.logo}>
          <Avatar className={classes.large}>
            <RasilniIcon height="40" width="40" />
          </Avatar>
        </div>

        {/* Second section - links */}
        <List aria-label="main mailbox folders" className={classes.links}>
          <Links handleDrawerToggle={handleDrawerToggle} />
        </List>

        {/* Third section - User Avatar */}
        <div className={classes.usernameSection}>
          <IconButton
            disableRipple={true}
            color="inherit"
            aria-label="arrow-drop"
            onClick={handleUserSettingClick}
            size="large"
          >
            <Avatar
              className={classes.large}
              alt={`${userInfo?.first_name?.[0]?.toUpperCase()}${userInfo?.last_name?.[0]?.toUpperCase()}`}
              src={(userInfo && userInfo?.avatar_url) || null}
              style={{
                backgroundColor: userInfo && userInfo?.avatar_url ? null : "#bababa",
              }}
            >
              {userInfo && userInfo.avatar_url
                ? null
                : `${userInfo?.first_name?.[0]?.toUpperCase()}${userInfo?.last_name?.[0]?.toUpperCase()}`}
            </Avatar>
          </IconButton>
          <Menu
            elevation={0}
            id={userSettingId}
            open={userSettingOpen}
            anchorEl={anchorElUserSetting}
            onClose={handleUserSettingClose}
            sx={{
              marginLeft: "10px",
              top: "-15px",
            }}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  bottom: 10,
                  left: -5,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-45%) rotate(-45deg)",
                  zIndex: 0,
                },
              },
            }}
          >
            <List component="nav" className={classes.List}>
              <Links showText profileOptions handleUserSettingClose={handleUserSettingClose} />
              <MenuItem
                aria-controls={themeOpen ? "theme-submenu" : undefined}
                aria-haspopup="true"
                onClick={handleThemeClick}
                sx={{
                  "&:hover": { backgroundColor: "none" },
                }}
              >
                <ListItemIcon>
                  <SettingsIcon sx={{ color: theme.palette.mainText }} />
                </ListItemIcon>
                <ListItemText primary="Theme" />
                {themeSubMenuOpen && anchorElTheme && (
                  <ThemeSubMenu
                    anchorEl={anchorElTheme}
                    open={themeSubMenuOpen}
                    handleClose={handleThemeClose}
                  />
                )}
              </MenuItem>
            </List>
          </Menu>
        </div>
      </Toolbar>
    </div>
  );
};

export default Header;
